/**
 * Unread-notification count hook. Drives the profile-menu chip and the
 * "Notifications" badge. Refetches on realtime INSERT (wired in
 * use-push-notifications.ts) and on mark-read mutations.
 */
import { useQuery } from '@tanstack/react-query'
import { supabase } from '../supabase'
import { useAuth } from './use-auth'
import { notificationKeys } from './use-notifications-inbox'

export function useNotificationsUnreadCount(): number {
  const { user } = useAuth()
  const userId = user?.id ?? ''

  const query = useQuery({
    queryKey: notificationKeys.unread(userId),
    queryFn: async () => {
      const { count, error } = await supabase
        .from('notifications')
        .select('id', { count: 'exact', head: true })
        .eq('profile_id', userId)
        .eq('is_read', false)
      if (error) throw error
      return count ?? 0
    },
    enabled: !!userId,
    staleTime: 15 * 1000,
  })

  return query.data ?? 0
}
